import React from "react";
import { Link } from 'react-router-dom';
import {Card, CardBody, Col, Container, Row } from 'reactstrap';
import MomentarilyCodesTable from "./components/MomentarilyCodesTable.jsx";

const MomentarilyCodesIndex = () => {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Momentarily Codes</h3>
          <h3 className="page-subhead subhead">
            <Link to="/">Home</Link> / Momentarily Codes
          </h3>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
                <MomentarilyCodesTable />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default MomentarilyCodesIndex;
